import cn from "classnames";
import { ElementSizeProps, ElementType } from "../types";

export const useElementSizeProps = <T extends ElementSizeProps>(
  props: T,
  el: ElementType
) => {
  // Remove size from props list to prevent passing down.
  const { size, ...rest } = props;

  // Create the new className with color classes added to existing class names.
  const output: string = cn(props.className, { [`${el}-${size}`]: size });

  // return the updated props;
  return { className: output, ...rest };
};
